import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setFilterType, selectFilterType } from '../store/slices/tenantSlice';

const TenantFilter = ({ counts }) => {
  const dispatch = useDispatch();
  const filterType = useSelector(selectFilterType);

  const filterButtonStyle = {
    padding: '8px 16px',
    borderRadius: '8px',
    marginRight: '8px',
    cursor: 'pointer',
    border: 'none'
  };

  const activeButtonStyle = {
    ...filterButtonStyle,
    backgroundColor: '#dbeafe',
    color: '#1e40af'
  };

  const inactiveButtonStyle = {
    ...filterButtonStyle,
    backgroundColor: '#f3f4f6',
    color: '#4b5563',
    ':hover': {
      backgroundColor: '#e5e7eb'
    }
  };

  return (
    <div style={{ display: 'flex', marginBottom: '24px' }}>
      <button
        style={filterType === 'all' ? activeButtonStyle : inactiveButtonStyle}
        onClick={() => dispatch(setFilterType('all'))}
      >
        All Tenants ({counts.all || 0})
      </button>
      <button
        style={filterType === 'master' ? activeButtonStyle : inactiveButtonStyle}
        onClick={() => dispatch(setFilterType('master'))}
      >
        👑 Master ({counts.master || 0})
      </button>
      <button
        style={filterType === 'regular' ? activeButtonStyle : inactiveButtonStyle}
        onClick={() => dispatch(setFilterType('regular'))}
      >
        🏢 Regular ({counts.regular || 0})
      </button>
    </div>
  );
};

export default TenantFilter;